import useTranslate from 'modules/local/useTranslate'
import React, {useContext, useState} from 'react'
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {Avatar} from "antd";
import {BsInfoCircleFill, BsPersonFill} from "react-icons/bs";
import {HeaderBlock} from "../../../MainPage/components/HeaderBlock";
import {ItemInformation} from 'components/common/ItemInformation'
import {formatSimplifyDate} from "../../../../helpers/dateUtils";
import getAvatar from "../../../../helpers/getAvatar";


const InformationTab = ({item}) => {
    const t = useTranslate()


    return (
        <div className="flex flex-col gap-2">
            MAY BE EVENT INFO
        </div>
    )
}

export const DetailViewForm = ({item, onCancel}) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)
    const [current, setCurrent] = useState('0')

    const {user, event_location, checkin_time, status} = item ?? {}

    const tabs = [
        {
            key: 0,
            label: 'information',
            content: <InformationTab item={item}/>,
        },
    ]

    return (
        <div className="flex flex-col gap-3">
            <div className="flex flex-col">
                <HeaderBlock
                    size={26}
                    icon={<BsInfoCircleFill size={14} className="text-blue-500"/>}
                    renderTitle={() => (
                        <span className="font-semibold text-sm text-blue-600 tracking-wider">
                            {t('personal information')}
                        </span>
                    )}
                    className="bg-blue-100"
                />
                <div className="mx-auto mt-3">
                    <Avatar
                        size={120}
                        className="flex flex-center background-200 rounded-lg"
                        src={getAvatar(user)}
                        icon={<BsPersonFill size={60} className="text-color-500"/>}
                    />
                </div>
                <div className="p-3 flex flex-col gap-1 border-b border-color-50 rounded-b-lg shadow-xs">
                    <div className="font-bold text-base text-color-000 leading-tight cursor-pointer">
                        {user?.patron_saint_name ? `${user?.patron_saint_name} ` : ''}
                        {user?.name}
                    </div>
                    <ItemInformation label="locations" value={event_location?.name} className="text-xs italic"/>
                    <ItemInformation label="time" value={formatSimplifyDate(checkin_time, 'fullTime')}
                                     className="text-xs italic"/>
                    <ItemInformation label="status" value={status === 1 ? t('success') : t('unsuccessful')}
                                     className="text-xs italic"/>
                </div>
            </div>

            <div className="flex justify-end p-3 mt-6 md:mt-8">
                <span onClick={onCancel} className="font-medium text-color-200 hover:text-color-000 cursor-pointer">
                  {t('close')}
              </span>
            </div>
        </div>
    )
}
